import styled from 'styled-components';
import { Collapse, Button } from 'react-bootstrap';
import { LuChevronDown } from 'react-icons/lu';
import InfoTooltip from '@components/infoTooltip/InfoTooltip';

const StyledArrow = styled(LuChevronDown)`
	transition: transform 0.2s;
	width: 1em;
	height: 1em;
	&.rotate-90 {
		transform: rotate(-180deg);
	}
`;

export const ToggleSlideButton = ({
	constrolsId,
	isOpen,
	setIsOpen,
	labelOpen = 'View details',
	labelClose = 'Hide details',
}) => {
	return (
		<Button
			variant="dark"
			onClick={() => setIsOpen(!isOpen)}
			className="d-flex align-items-center gap-1 p-0"
			aria-expanded={isOpen}
			aria-controls={constrolsId}>
			<InfoTooltip
				tooltipContainerId="tooltip-sidebar-root"
				placement="top"
				data-tooltip-offset={20}
				content={isOpen ? labelClose : labelOpen}
				showIcon={false}>
				<span className="d-flex align-items-center p-1">
					{' '}
					<StyledArrow className={`${isOpen ? 'rotate-90' : ''}`} />
				</span>
			</InfoTooltip>
		</Button>
	);
};

export const ToggleSlideContent = ({ id, isOpen, children }) => {
	return (
		<Collapse in={isOpen}>
			<div id={id}>{children}</div>
		</Collapse>
	);
};
